module.exports = __webpack_public_path__ + "static/media/azf.06645633.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/azf.svg
// module id = 960
// module chunks = 0